import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import { DataTable } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	okCell: {
		backgroundColor: '#a5d6a7',
	},
	nokCell: {
		backgroundColor: '#ef9a9a',
	}
}));

const SiteReportTable = (props) => {
	const { name, structure, data, ...rest } = props;
	const classes = useStyles();
	const [columns, setColumns] = useState(structure);

	useEffect(() => {
		setColumns(
			structure.map((column) => ({
				name: column.name,
				label: column.label,
				options: {
					display: column.options.display,
					filterType: column.options.filterType,
					customFilterListOptions: {
						render: v => `${column.label} - ${v}`
					},
					setCellProps: value => ({
						className: clsx({
							[classes.okCell]: value === 'OK',
							[classes.nokCell]: value === 'NOK'
						})
					}),
				},
			}))
		);
	}, [data]);

	return (
		<div {...rest} className={clsx(classes.root)}>
			<DataTable
				id={name}
				title={name}
				data={data}
				columns={columns}
				rowsPerPage={10}
				tableBodyMaxHeight="30em"
				tableBodyCellMaxWidth="250"
			/>
		</div>
	);
};

SiteReportTable.propTypes = {
	name: PropTypes.string.isRequired,
	structure: PropTypes.array.isRequired,
	data: PropTypes.array.isRequired
};

export default SiteReportTable;
